export const addDynatraceIdentifier = (identifier_cpf, identifier_mdm, identifier_admission) => {
  let identifier;
  if (window.dtrum && typeof window.dtrum.identifyUser === 'function') {
    identifier = identifier_cpf;
    if (identifier_mdm) identifier = `${identifier_cpf}_${identifier_mdm}`;

    if (identifier_admission)
      identifier = `${identifier_cpf}_${identifier_mdm}_${identifier_admission}`;

    window.dtrum.identifyUser(identifier);
  }
};
